export default "__VITE_ASSET__harIBqHg__"